import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { SharedService } from '../../core/services/shared.service';
import { AuthService } from '../../core/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { PlatformService } from '../../core/services/platform.service';
import { LayoutService } from '../../core/services/layout.service';
import { Router } from '@angular/router';
import { AppManagerService } from 'app-manager';
import { TranslateService } from '@ngx-translate/core';
import { ProfileService } from 'profile';
import { ConnectService } from '../../core/global-layout/language-service';
//import { FlagService } from '../../core/global-layout/flag-service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  submitted: boolean = false;
  isShow = false;
  userName: string;
  roleName: boolean;
  bannerDetails: any = {
    backgroundIcon: "",
    backgroundImage: "",
    buttonLabel: "",
    buttonUrl: "",
    description: "",
    title: "",
  };
  selectedPlan: any = {};
  privacyData: any = '';
  @Input() RightNavData: any;
  appTitle = 'QR Activation Tool';
  hideSubscribe: boolean = false;
  isAccess: boolean;
  getCurrentAppInfo: any = { applicationDetails: { isSubscriptionApprovalRequired: true, isUnsubscribeApprovalRequired: true } };
  userType: boolean = false;
  isOpen: String;
  selectedLang: String;
  appManagerInfo: Array<any> = [];
  // subscription: Subscription;
  shortCutArray: Array<any> = [1, 2, 3, 4, 5];
  homeDetails: Array<any> = [];
  pinnedApps;
  facilityDetails: any = {};
  serviceAgreement: any;
  dataUsageAgreement: any;
  // facilitySelection: Subscription;
  facilitySubscriptionSetup: any = {};
  PlanData: Array<any> = [];
  policyData: Array<any> = [];
  checkFlag: any = {};
  userRole: any = '';
  facilityInfo: any = {
    SAPid: '',
    facilityName: ''
  };
  constructor(
    // private dhhpAlert: DhhpAlertComponent,
    private sharedService: SharedService,
    public authService: AuthService,
    private dialogBox: MatDialog,
    private platformService: PlatformService,
    private userService: LayoutService,
    private router: Router,
    private appManagerService: AppManagerService,
    private translate: TranslateService,
    private profileService: ProfileService,
    private connectionService: ConnectService,
    //private flagService: FlagService,
  ) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {
  }

  goToGenerateQR() {
      this.router.navigateByUrl('/bulk-activation');
  }

  ngOnDestroy() {
    // if (this.subscription)
    //   this.subscription.unsubscribe();
    // if (this.subscriptionLogin)
    //   this.subscriptionLogin.unsubscribe();
    // if (this.facilitySelection)
    //   this.facilitySelection.unsubscribe();
  }

  consentView(str: String){

  }
}
